export const BOARD_CONTENT_ID = 'board-content';
export const DOC_ITEM_KABAN_WIDTH = 262;
